import React from 'react'
import connect from 'redux-connect-decorator'
import { Link } from 'react-router-dom'
import Div100vh from 'react-div-100vh'
import { Helmet } from 'react-helmet'
import { Flex, WhiteSpace, WingBlank } from 'antd-mobile'
import { Button } from 'components'
import { closeWebView, openByBrowser } from 'utils/JSBridge'
import { languageChange } from 'store/siteConfig'
import { PayByInfo, customEvent, openLink } from 'utils'
import { compare } from 'compare-versions'

@connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  { languageChange }
)
class MiniProgramRedirect extends React.Component {
  constructor(props) {
    super(props)
    languageChange('en')
    customEvent({
      page_name: 'payby_redirect_page',
      event_name: 'display',
      element_name: 'pageview',
    })
  }

  getContentByType(bizType) {
    const content = {
      remittance: {
        title: 'Send money worldwide with ease on Botim',
        subTitle: 'Simplify your international transfer, use Botim',
        footnote: 'You will be redirected to <b>Botim app</b> for seamless communication and enabling PayBy\'s International Transfer feature within Botim for your convenience.',
        pageTitle: 'International Transfer',
        redirectUrl: 'https://botim.me/mp/b/?app=me.botim.pay.remittanceapp%2Findex.html%23%2Fremittance%3Futm_source%3Dpayby%26utm_medium%3Dentrance'
      },
      topup: {
        title: 'Top up your mobile easily on Botim',
        subTitle: 'Simplify mobile top ups with Botim\'s latest bills & recharges feature',
        footnote: 'You will be directed to <b>Botim app</b> to enable seamless communication and mobile top ups.',
        pageTitle: 'Mobile Top Up',
        redirectUrl: 'https://botim.me/mp/b/?app=developers.ae.utilitypayment%2Findex.html%23%2F%3Futm_source%3Dpayby%26utm_medium%3Dentrance'
      },
      bills: {
        title: 'Pay your bills easily on Botim',
        subTitle: 'Simplify bill payments with Botim\'s latest bills & recharges feature',
        footnote: 'You will be directed to <b>Botim app</b> to enable seamless communication and bill payments.',
        pageTitle: 'Bill Payments',
        redirectUrl: 'https://botim.me/mp/b/?app=developers.ae.utilitypayment%2Findex.html%23%2F%3Futm_source%3Dpayby%26utm_medium%3Dentrance'
      }
    }

    return content[bizType] || content.remittance
  }

  render() {
    const params = new URLSearchParams(window.location.search)
    const bizType = params.get('biz_type') || 'remittance'

    const content = this.getContentByType(bizType)
    return (
      <Div100vh>
        <Helmet>
          <title>{content.pageTitle}</title>
        </Helmet>
        <Flex
          direction='column'
          justify='center'
          align='center'
          style={{
            height: '100%',
            position: 'relative',
          }}
        >
          <img
            style={{ position: 'absolute', width: '100%', top: 0, zIndex: -1 }}
            src={require('./images/image 51.png')}
          />
          <Flex.Item>
            <Flex
              direction='column'
              justify='center'
              align='center'
              style={{ height: '100%' }}
            >
              <WingBlank className='text-center'>
                <img height={64} src={require('./images/Frame 1087124.png')} />
                <WhiteSpace size='xl' />
                <WhiteSpace size='xl' />
                <div>
                  <b>{content.title}</b>
                </div>
                <WhiteSpace />
                <div className='gray font-sm'>
                  {content.subTitle}
                </div>
                <WhiteSpace size='xl' />
                <WhiteSpace size='xl' />
                <Button
                  type='primary'
                  name='custom'
                  onClick={() => {
                    customEvent({
                      page_name: 'payby_redirect_page',
                      event_name: 'click',
                      element_name: 'continue',
                    })
                    const { PayBySDKVersion = '0.0.0' } = PayByInfo()

                    if (compare(PayBySDKVersion, '3.1.0', '>=')) {
                      openByBrowser(content.redirectUrl)
                    } else {
                      openLink(content.redirectUrl, '_blank')
                    }
                  }}
                >
                  Continue
                </Button>
                <WhiteSpace />
                <Button
                  name='custom'
                  className='am-button-gray'
                  onClick={() => closeWebView()}
                >
                  Cancel
                </Button>
                <WhiteSpace size='xl' />
                {bizType === 'topup' && (
                  <Link
                    className='green font-sm'
                    to='/topUp/auto-recharge/list'
                  >
                    Disable Auto-Recharge
                  </Link>
                )}
                <WhiteSpace size='xl' />
                <WingBlank>
                  <div className='font-xs gray' dangerouslySetInnerHTML={{ __html: content.footnote }} />
                </WingBlank>
              </WingBlank>
            </Flex>
          </Flex.Item>
          <div className='text-center'>
            <div className='font-10'>
              Powered by{' '}
              <img
                style={{ verticalAlign: 'middle' }}
                height={24}
                src='/images/logo-payby-green.png'
              />
            </div>
            <WhiteSpace size='xs' />
            <div className='font-xs'>
              <a
                className='green'
                href='https://alioss.payby.com/PayByUserAgreement_LATEST.html'
              >
                Terms and Conditions
              </a>{' '}
              |{' '}
              <a
                className='green'
                href='https://alioss.payby.com/BasePrivacyPolicy_LATEST.html'
              >
                Privacy Policy
              </a>
            </div>
            <WhiteSpace size='xl' />
          </div>
        </Flex>
      </Div100vh>
    )
  }
}

export default MiniProgramRedirect
